const router = [
  {
    name: '404',
    path: '/404',
    component: () => import('@/views/error/404'),
  },
  {
    name: '500',
    path: '/500',
    component: () => import('@/views/error/500'),
  },
  {
    name: '408',
    path: '/408',
    component: () => import('@/views/error/408'),
  },
  {
    name: '502',
    path: '/502',
    component: () => import('@/views/error/502'),
  },
];

export default router;
